import { createContext, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

const DEFAULTS = {
  company_name: "Home Haven Srl",
  email: "info@homehaven.it",
  pec: "homehaven@pec.it",
  phone: "",
  whatsapp_number: "393288565455",
  whatsapp_message: "Buongiorno, vorrei avere informazioni su Home Haven.",
  instagram: "https://www.instagram.com/homehaven_srl",
  investor_disclaimer: "",
  hero_image: "",
};

const SettingsContext = createContext(DEFAULTS);

export const SettingsProvider = ({ children }) => {
  const { data } = useQuery({ queryKey: ["settings"], queryFn: () => api.get("/settings").then((r) => r.data), staleTime: 5 * 60_000 });
  return <SettingsContext.Provider value={{ ...DEFAULTS, ...(data || {}) }}>{children}</SettingsContext.Provider>;
};

export const useSettings = () => useContext(SettingsContext);

export const whatsappLink = (s) =>
  `https://wa.me/${(s.whatsapp_number || "").replace(/\D/g, "")}?text=${encodeURIComponent(s.whatsapp_message || "")}`;
